var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
var wrapper = {
    padding: '16px'
};
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        borderRadius: '4px'
    },
    logoWrapper: __assign({ flex: '0 0 32px', display: 'flex', justifyContent: 'center', alignItems: 'center' }, wrapper),
    contentWrapper: __assign(__assign({}, wrapper), { flex: 1 }),
    ctaWrapper: __assign({ display: 'flex', justifyContent: 'center', alignItems: 'center' }, wrapper)
}); });
export function Alert(_a) {
    var backgroundColor = _a.backgroundColor, children = _a.children, icon = _a.icon, callToAction = _a.callToAction, boxProps = __rest(_a, ["backgroundColor", "children", "icon", "callToAction"]);
    var classes = useStyles();
    var mergedClasses = [classes.root, boxProps.className].join(' ');
    return (React.createElement(Box, __assign({}, boxProps, { style: { backgroundColor: backgroundColor }, className: mergedClasses }),
        React.createElement("div", { className: classes.logoWrapper }, icon),
        React.createElement("div", { className: classes.contentWrapper }, children),
        React.createElement("div", { className: classes.ctaWrapper }, callToAction)));
}
//# sourceMappingURL=AlertBase.js.map